export default __webpack_public_path__ + "static/media/117t.dce0f9c8.jpg";